"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const ViewWorkHeader_1 = __importDefault(require("@Components/ViewWork/Headers/ViewWorkHeader"));
const SongwriterSearchedWorkHeader = ({ work }) => (react_1.default.createElement(ViewWorkHeader_1.default, { work: work, backText: '< Back to search results' }));
exports.default = SongwriterSearchedWorkHeader;
